"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _useCurrentQuestion2 = require("../../hooks/questionnaire/useCurrentQuestion");
var _constants = require("../../utils/constants");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _BaseComponents = require("../StyledComponents/BaseComponents");
var _QuestionWithBudget = require("./QuestionWithBudget");
var _QuestionWithChoices = _interopRequireDefault(require("./QuestionWithChoices"));
var _QuestionWithImages = _interopRequireDefault(require("./QuestionWithImages"));
var _QuestionWithMulti = _interopRequireDefault(require("./QuestionWithMulti"));
var _QuestionWithRange = _interopRequireDefault(require("./QuestionWithRange"));
var _QuestionWithSearch = _interopRequireDefault(require("./QuestionWithSearch"));
var _QuestionWithAddressSearch = _interopRequireDefault(require("./QuestionWithAddressSearch"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledGridRow = (0, _BaseComponents.GrayBackground)(_r10SourceLibrary.GridRow);
var StyledQuestionWrapper = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n"])));
var QuestionnaireBody = function QuestionnaireBody() {
  var _useCurrentQuestion = (0, _useCurrentQuestion2.useCurrentQuestion)(),
    question = _useCurrentQuestion.question,
    selections = _useCurrentQuestion.selections;
  var QuestionComponent = function QuestionComponent(question) {
    switch (question.type) {
      case _constants.QUESTION_TYPE.CHOICES:
        return _QuestionWithChoices.default;
      case _constants.QUESTION_TYPE.RANGE:
        return (0, _questionnaireUtil.isBudgetQuestion)(question) ? _QuestionWithBudget.QuestionWithBudget : _QuestionWithRange.default;
      case _constants.QUESTION_TYPE.MULTI:
        return (0, _questionnaireUtil.isBudgetQuestion)(question) ? _QuestionWithBudget.QuestionWithBudget : _QuestionWithMulti.default;
      case _constants.QUESTION_TYPE.SEARCH:
        return _QuestionWithSearch.default;
      case _constants.QUESTION_TYPE.IMAGE:
        return _QuestionWithImages.default;
      case _constants.QUESTION_TYPE.ADDRESS_SEARCH:
        return _QuestionWithAddressSearch.default;
      default:
        return null;
    }
  };
  if (!question) {
    return null;
  }
  var QuestionComponentInstance = QuestionComponent(question);
  if (!QuestionComponentInstance) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 7,
      bottom: 7
    }
  }, /*#__PURE__*/_react.default.createElement(StyledGridRow, {
    align: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 6,
      left: 4,
      right: 4
    }
  }, /*#__PURE__*/_react.default.createElement(StyledQuestionWrapper, {
    align: 'stretch'
  }, /*#__PURE__*/_react.default.createElement(QuestionComponentInstance, {
    question: question,
    selections: selections
  }))))));
};
var _default = QuestionnaireBody;
exports.default = _default;